<template>
    <div id="contenedor-editar-caracteristica-subtipo-infraestructura">
      <v-form v-model="formularioValido" ref="editarCaracteristicaSubtipoInfraestructura">
        <v-card>
          <v-card-title class="secondary--text">
            Editar caracteristica subtipo de infraestructura
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <custom-autocomplete
              v-model="subtipoInfraestructuraCaracteristicas.idSubtipoInfraestructura"
              label="Subtipo de Infraestructura"
              :items="getSubtiposInfraestructura"
              item-text="descripcion"
              item-value="id"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-autocomplete>
            <custom-text-field
              label="Descripción"
              v-model="subtipoInfraestructuraCaracteristicas.descripcion"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>
            <custom-text-field
              label="Tipo"
              v-model="subtipoInfraestructuraCaracteristicas.tipo"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixActualizarCaracteristicaSubtipoInfraestructura"
              :disabled="!formularioValido  || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Actualizar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </template>

<script>
import mixCaracteristicasSubtiposInfraestructura from './mixCaracteristicasSubtiposInfraestructura';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarCaracteristicaSubtipoInfraestructura',
  mixins: [mixCaracteristicasSubtiposInfraestructura],
  props: {
    subtipoInfraestructuraCaractetristicaEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomAutocomplete,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      subtipoInfraestructuraCaracteristicas: {
        idSubtipoInfraestructura: this.subtipoInfraestructuraCaractetristicaEditar
          .idSubtipoInfraestructura,
        descripcion: this.subtipoInfraestructuraCaractetristicaEditar.descripcion,
        tipo: this.subtipoInfraestructuraCaractetristicaEditar.tipo,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.editarCaracteristicaSubtipoInfraestructura.reset();
    },
  },
};
</script>

  <style lang="scss" scoped>

  </style>
